





































































































































  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import store from "@/store";
  import {checkGuide} from "@/services/api";
  import ZhiYing from '@/assets/img/zhiying.svg';
import ZhiYingHover from '@/assets/img/zhiyinghover.svg';
  @Component
  export default class YcAside extends Vue {
    get collapsed() {
      return this.$store.state.collapsed;
    }
    // 当前激活的菜单
    private activeNav: string = '/item/list';
    // 跳转到子页面时的菜单栏的显示控制
    private navFormat: {reg: any, showPath: string}[] = [
      {
        reg: /^(\/strategy\/flow)/,
        showPath: '/marketing/process/list'
      },{
        reg: /^(\/user\/grouping\/setting)/,
        showPath: '/user/grouping'
      },{
        reg: /^(\/user\/grouping\/upload)/,
        showPath: '/user/grouping'
      },{
        reg: /^(\/wheel_of_fortune\/setting)/,
        showPath: '/wheel_of_fortune/list'
      }
    ]

    public isShowGuide = false;
    public zhiyingState = false;
    created(){
      this.setNav(this.$route, null)
        this.getGuide()
    }
    collapse() {
      store.commit('SET_IS_COLLAPSE', !this.collapsed)
    }

    /**
     * 监控路由变化设置导航激活
     * @param newVal
     * @param oldVal
     */
    @Watch('$route')
    setNav(newVal: any, oldVal: any): string {
      for (let item of this.navFormat) {
        if (item.reg.test(newVal.path)) {
          return this.activeNav = item.showPath
        }
      }
      this.activeNav = newVal.path
      return this.activeNav = newVal.path
    };

    // 获取新手指引图标是否显示
    async getGuide() {
      const res = await checkGuide({});
      // console.log(res, 'res');
      if (res.data && res.data.code === 0) {
        this.isShowGuide = res.data.data.show
      }
    }

    setZhiYingState(state) {
      this.zhiyingState = state;
    }
    goToAccessGuide() {
      this.$router.push('/cartsee-new/accessGuide');
    }
  }

